import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AccessLog, AccessLogsState } from '@/types/log.types';

const initialState: AccessLogsState = {
  list: [],
  totalCount: 0,
  loading: false,
  error: null,
  logDetails: { data: null, loading: false },
};

const accessLogsSlice = createSlice({
  name: 'accessLogs',
  initialState,
  reducers: {
    fetchAccessLogsRequest(state, _action: PayloadAction<{ page: number; limit: number; search?: string; companyId?: string; dateFrom?: string; dateTo?: string }>) {
      state.loading = true; state.error = null;
    },
    fetchAccessLogsSuccess(state, action: PayloadAction<{ list: AccessLog[]; totalCount: number }>) {
      state.loading = false; state.list = action.payload.list; state.totalCount = action.payload.totalCount;
    },
    fetchAccessLogsFailure(state, action: PayloadAction<string>) {
      state.loading = false; state.error = action.payload;
    },
    fetchAccessLogDetailsRequest(state, _action: PayloadAction<{ companyId: string; page: number; limit: number }>) {
      state.logDetails = { data: null, loading: true };
    },
    fetchAccessLogDetailsSuccess(state, action: PayloadAction<Record<string, unknown>>) {
      state.logDetails = { data: action.payload, loading: false };
    },
    fetchAccessLogDetailsFailure(state) {
      state.logDetails = { data: null, loading: false };
    },
    clearLogDetails(state) {
      state.logDetails = { data: null, loading: false };
    },
  },
});

export const {
  fetchAccessLogsRequest, fetchAccessLogsSuccess, fetchAccessLogsFailure,
  fetchAccessLogDetailsRequest, fetchAccessLogDetailsSuccess, fetchAccessLogDetailsFailure,
  clearLogDetails,
} = accessLogsSlice.actions;
export default accessLogsSlice.reducer;
